import * as actionTypes from '../../constants/actionTypes';

const initialState = {};

export default function(state = initialState, action) {
  switch (action.type) {
    case actionTypes.GET_UNITS_ERROR:
    case actionTypes.GET_UNITS_SUCCESS:
      if (action.payload.type === 'unit1') {
        return action.payload.response.map(unit => {
          return { label: unit.type, value: unit.uuid };
        });
      }
      return state;
    default:
      return state;
  }
}
